<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="line"></div>
            <div class="message bh bstart c_666 fz_24 border-bottom">
                <div class="ico-warning bg-contain"></div>请上传您本人的身份证和银行卡照片，以用于打款
            </div>
            <validation-observer v-slot="{ invalid }" ref="form">
                <validation-provider
                    :rules="{required: { allowFalse: false } }"
                    :customMessages="{required:'请上传您本人的身份证照片'}"
                >
                    <input type="hidden" v-model="isUpId" />
                </validation-provider>
                <validation-provider rules="required" v-slot="{ errors }" name="姓名">
                    <van-field
                        v-model="formData.verifiedName"
                        clearable
                        maxlength="6"
                        placeholder="请上传您本人的身份证照片"
                        class="border-bottom"
                        :readonly="!isUpId"
                        @click="onUpClick(isUpId,'CardIdUp')"
                    >
                        <div slot="right-icon" class="bh bstart">
                            <zb-warning :message="errors[0]" />
                            <div class="ico-scanning bg-contain">
                                <div class="scanning-el" @click.stop="onUpClick(false,'CardIdUp')"></div>
                            </div>
                        </div>
                    </van-field>
                </validation-provider>
                <validation-provider
                    rules="required|idCard"
                    name="身份证号码"
                    v-slot="{ errors }"
                    v-show="isUpId"
                >
                    <van-field
                        v-model="formData.idCardNumber"
                        maxlength="18"
                        clearable
                        placeholder="请输入身份证号码"
                        class="border-bottom"
                    >
                        <zb-warning slot="right-icon" :message="errors[0]" />
                    </van-field>
                </validation-provider>
                <validation-provider
                    :rules="{required: { allowFalse: false } }"
                    :customMessages="{required:'请上传您本人的银行卡照片'}"
                >
                    <input type="hidden" v-model="isUpBank" />
                </validation-provider>
                <validation-provider
                    rules="required"
                    v-slot="{ errors }"
                    :customMessages="{required:'请选择所属银行'}"
                >
                    <zbSelect
                        v-model="formData.bankCardTypeId"
                        :fieldOptions="fieldOptions"
                        :readonly="isUpBank"
                        :vClass="isUpBank&&'border-bottom'"
                        :errorMessage="errors[0]"
                        :data="bankTypeData"
                        showName="bankName"
                        @click="onUpClick($event,'CardBankUp')"
                        @select="onBankSelect"
                    ></zbSelect>
                </validation-provider>
                <validation-provider
                    rules="required|bankNo"
                    v-slot="{ errors }"
                    name="银行卡号"
                    v-show="isUpBank"
                >
                    <van-field
                        v-model="formData.bankCardNumber"
                        clearable
                        maxlength="19"
                        placeholder="请输入银行卡号"
                    >
                        <zb-warning slot="right-icon" :message="errors[0]" />
                    </van-field>
                </validation-provider>
                <div class="line"></div>
                <validation-provider rules="required|mobile" v-slot="{ errors }" name="手机号">
                    <van-field
                        v-model="formData.verifiedTelephone"
                        clearable
                        maxlength="11"
                        placeholder="请填写本人的手机号，用户接收短信通知"
                    >
                        <zb-warning slot="right-icon" :message="errors[0]" />
                    </van-field>
                </validation-provider>
                <validation-provider
                    :rules="{ required: { allowFalse: false } }"
                    tag="div"
                    class="protol"
                    :customMessages="{required:'请同意服务协议'}"
                >
                    <van-checkbox v-model="checked">
                        <div class="fz_24 c_999">
                            已阅读并同意
                            <span
                                class="c_warning"
                                @click.stop="go('DealInfo',{data:'transferInstructions2',title:'服务协议'})"
                            >《服务协议》</span>
                        </div>
                    </van-checkbox>
                </validation-provider>
                <div class="bh bc footBar">
                    <van-button
                        :class="getBtnCls(invalid)"
                        @click="onSaveClick"
                        class="btn btn-goodbuy"
                    >
                        <span class="fz_30 btn-span">立即认证</span>
                    </van-button>
                </div>
            </validation-observer>
        </div>
    </div>
</template>

<script>
import { verificationUser } from "@/api/card";
import { user } from "@/mixin/user";
import { mixinValid } from "@/mixin/valid";
import zbSelect from "@/components/input/Select";
export default {
    mixins: [user, mixinValid],
    name: "MoneyCertification",
    components: { zbSelect },
    data() {
        return {
            formData: {},
            checked: false,
            fieldOptions: {
                placeholder: "请上传您本人的银行卡照片"
            }
        };
    },
    computed: {
        // 是否上传银行卡
        isUpBank() {
            return this.$store.state.money.isUpBank;
        },
        // 是否上传身份证
        isUpId() {
            return this.$store.state.money.isUpId;
        },
        // 可选银行卡列表
        bankTypeData() {
            return this.$store.getters["money/bankTypeData"];
        },
        // 银行卡认证信息
        bankInfo() {
            return {
                isUp: this.isUpBank,
                data: this.$store.state.money.bankData
            };
        },
        // 身份证认证信息
        idInfo() {
            return {
                isUp: this.isUpId,
                data: this.$store.state.money.idData
            };
        }
    },
    watch: {
        // 更新上传身份证
        idInfo: {
            handler(v) {
                this.upFormData(v);
            },
            immediate: true
        },
        // 更新上传银行卡
        bankInfo: {
            handler(v) {
                this.upFormData(v);
            },
            immediate: true
        }
    },
    methods: {
        // 页面返回
        viewBack() {
            this.$store.state.money.isUpBank = false;
            this.$store.state.money.isUpId = false;
        },
        // 登录成功
        userLoginend() {
            this.$store.dispatch("money/bankTypeData");
            if (this.$store.state.isDev) {
                this.formData.verifiedTelephone = "18784012064";
            }
        },
        // 更新数据
        upFormData(v) {
            if (v.isUp) {
                const me = this;
                me.formData = Object.assign(me.formData, v.data);
            }
        },
        // 更新银行卡名称
        onBankSelect(v) {
            this.formData.bankName = v.text;
        },
        // 点击进入认证页面
        onUpClick(v, go) {
            if (!v) {
                this.isDestroy = false;
                this.go(go);
            }
        },
        // 保存
        onSaveClick() {
            const me = this;
            me.validForm().then(() => {
                verificationUser(me.formData).then(() => {
                    me.$store.dispatch("money/verificationInfo", true);
                    me.backGo();
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
.topbar-container {
    background-color: #f7f8f8;
}
.message {
    padding: 30px;
    background-color: #fff;
    .ico-warning {
        width: 26px;
        height: 26px;
        margin: 3px 12px 0 0;
    }
}
/deep/ .van-cell {
    padding: 40px 30px;
}
/deep/.border-bottom {
    &:after {
        width: calc(100% - 60px);
        //兼容ios写法
        left: 30px;
        border-color: #e5e5e5;
    }
}
.protol {
    margin: 96px 0 0 122px;
    width: 510px;
}
.footBar {
    margin-top: 35px;
    .btn-goodbuy {
        width: 510px;
        height: 76px;
    }
}
</style>
